import react from 'react';
function Card({image , details}){
    const BASE_URL = '/images';

    return(
        <div className='w-[500px] h-[400px]  bg-[#f2f8ff)] flex flex-col items-center mt-10'>
            <img decoding='async' alt='bottle' src={`${BASE_URL}/${image}` } className='w-[300px] justify-center'/>
            <br/>
            <h3 className='font-ibmArabic font-extrabold'>{details}</h3>
        </div>
    )
}
export default Card;